import axios from 'axios';
import { GetOptions, PostOptions, PostOptions2 } from './request'
import { Decrypt3des } from '@/api/desEncrypt'
import { Message, Loading } from 'element-ui'
//获取userSig
export async function getUserSig (params) {
    const options = PostOptions(params, '/api/tencent/getUserSig')
    let { data } = await axios(options);
    if (data.code != 200) return Message({ type: "error", message: data.msg })
    let res = Decrypt3des(data.data)
    return res
}

//获取图片类型
export async function getParam (params) {
    const options = PostOptions(params, '/api/videoConfig/getParam')
    let { data } = await axios(options);
    if (data.code != 200) return Message({ type: "error", message: data.msg })
    let res = JSON.parse(Decrypt3des(data.data))
    return res
}
//获取申请信息
export async function getApplymess (params) {
    const options = PostOptions(params, '/api/bt/getApplyInfo')
    let { data } = await axios(options);
    if (data.code != 200) return Message({ type: "error", message: data.msg })
    let res = JSON.parse(Decrypt3des(data.data))
    return res
}

//修改申请状态
export async function hangup (params) {
    const options = PostOptions(params, '/api/bt/hangup')
    let { data } = await axios(options);
    if (data.code != 200) return Message({ type: "error", message: data.msg })
    let res = JSON.parse(Decrypt3des(data.data))
    return res
}


//保存时长
export async function callTime (params) {
    const options = PostOptions(params, '/api/countTime/callTime')
    let { data } = await axios(options);
    if (data.code != 200) return Message({ type: "error", message: data.msg })
    return data
}

//开始录制
export async function record (params) {
    const options = PostOptions(params, '/api/tencent/record')
    let { data } = await axios(options);
    return data
}

//结束录制
export async function recordend (params) {
    const options = PostOptions(params, '/api/tencent/recordend')
    let { data } = await axios(options);
    if (data.code != 200) return Message({ type: "error", message: data.msg })
    // let res =JSON.parse(Decrypt3des(data.data))
    return data
}

//上传图片
export async function uploadImg (params) {
    const options = PostOptions2(params, '/api/common/uploadImg')
    let { data } = await axios(options);
    if (data.code != 200) return Message({ type: "error", message: data.msg })
    let res = Decrypt3des(data.data)
    return {
        data:res,
        code:data.code
    }
}
//删除图片
export async function delFile (params) {
    const options = PostOptions(params, '/api/common/delFile')
    let { data } = await axios(options);
    if (data.code != 200) return Message({ type: "error", message: data.msg })
    return data
}
//保存图片
export async function saveApply (params) {
    const options = PostOptions(params, '/api/videoApply/saveApply')
    let { data } = await axios(options);
    if (data.code != 200) return Message({ type: "error", message: data.msg })
    let res = data
    return res
}

//保存图片
export async function queueDelete (params) {
    const options = PostOptions(params, '/api/mq/queueDelete')
    let { data } = await axios(options);
    if (data.code != 200) return Message({ type: "error", message: data.msg })
    let res = data
    return res
}

//推送信息
export async function initiateVideo (params) {
    const options = PostOptions(params, '/api/videoApply/initiateVideo')
    let { data } = await axios(options);
    let res = data
    if (data.code != 200) return Message({ type: "error", message: data.msg })
    return res
}
